import {
    MEMBER_CYCLE_PURCHASE_ROUTER,
    MEMBER_CYCLE_PURCHASE_PRODUCT_SELECT_ROUTER,
    MEMBER_CYCLE_PURCHASE_CONFIRM_ROUTER,
    MEMBER_CYCLE_PURCHASE_SUCCESS_ROUTER,
    MEMBER_CYCLE_PURCHASE_PENDING_CHANGE_ROUTER,
} from '@Router/routerPath';
import {
    CyclePurchasePage,
    CyclePurchaseProductSelectPage,
    CyclePurchaseConfirmPage,
    CyclePurchaseSuccessPage,
    CyclePurchasePendingChangePage,
} from '@Local/CyclePurchase';

const CyclePurchaseRouter = [
    {
        description: '循環訂單更換商品',
        static: true,
        exact: true,
        path: MEMBER_CYCLE_PURCHASE_ROUTER,
        href: MEMBER_CYCLE_PURCHASE_ROUTER,
        as: CyclePurchasePage,
    },
    {
        description: '循環訂單更換商品－選擇商品',
        static: true,
        exact: true,
        path: MEMBER_CYCLE_PURCHASE_PRODUCT_SELECT_ROUTER,
        href: MEMBER_CYCLE_PURCHASE_PRODUCT_SELECT_ROUTER,
        as: CyclePurchaseProductSelectPage,
    },
    {
        description: '循環訂單更換商品－確認生效時機',
        static: true,
        exact: true,
        path: MEMBER_CYCLE_PURCHASE_CONFIRM_ROUTER,
        href: MEMBER_CYCLE_PURCHASE_CONFIRM_ROUTER,
        as: CyclePurchaseConfirmPage,
    },
    {
        description: '循環訂單更換商品－變更成功',
        static: true,
        exact: true,
        path: MEMBER_CYCLE_PURCHASE_SUCCESS_ROUTER,
        href: MEMBER_CYCLE_PURCHASE_SUCCESS_ROUTER,
        as: CyclePurchaseSuccessPage,
    },
    {
        description: '循環訂單更換商品－變更紀錄',
        static: true,
        path: MEMBER_CYCLE_PURCHASE_PENDING_CHANGE_ROUTER,
        href: MEMBER_CYCLE_PURCHASE_PENDING_CHANGE_ROUTER,
        as: CyclePurchasePendingChangePage,
    },
];

export default CyclePurchaseRouter;
